import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUserXs = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 1C6.34315 1 5 2.34315 5 4V5C5 6.65685 6.34315 8 8 8C9.65685 8 11 6.65685 11 5V4C11 2.34315 9.65685 1 8 1ZM8 2C6.89543 2 6 2.89543 6 4V5C6 6.10457 6.89543 7 8 7C9.10457 7 10 6.10457 10 5V4C10 2.89543 9.10457 2 8 2Z'
    />
    <path d='M3.08395 10.0839C3.71662 9.45127 4.58738 9 5.5 9C5.77614 9 6 9.22386 6 9.5C6 9.77614 5.77614 10 5.5 10C4.91262 10 4.28338 10.2987 3.79105 10.7911C3.29873 11.2834 3 11.9126 3 12.5V14H13V12.5C13 11.9126 12.7013 11.2834 12.2089 10.7911C11.7166 10.2987 11.0874 10 10.5 10C10.2239 10 10 9.77614 10 9.5C10 9.22386 10.2239 9 10.5 9C11.4126 9 12.2834 9.45127 12.9161 10.0839C13.5487 10.7166 14 11.5874 14 12.5V15H2V12.5C2 11.5874 2.45127 10.7166 3.08395 10.0839Z' />
  </svg>
);
export default SvgUserXs;
